import { Component } from '@angular/core';

export const LOADER_PRESET_TOKEN = 'Fbfa';

@Component({
  selector: 'full-loader',
  template: `
  <div class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto" cdkScrollable>

    <!-- Main -->
    <div class="flex-auto">
       <div class="bg-transparent w-full h-full flex justify-center items-center min-h-full" style="
    z-index: 10;
    cursor: wait;
    pointer-events: none;
    top: 9%;
    left: 2%;
    margin: 0%;
    width: 96%;
    ">
    <!-- height: 90%; -->
  <div style="display: flex">
    <div class="dot-loader"></div>
    <div class="dot-loader dot-loader--2"></div>
    <div class="dot-loader dot-loader--3"></div>
  </div>
</div>
</div>
</div>
  `,
  host: { class: 'w-full' },
  styles: [`
.dot-loader {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: var(--desku-primary);
  position: relative;
  -webkit-animation: 1.2s grow ease-in-out infinite;
  animation: 1.2s grow ease-in-out infinite;
}

.dot-loader--2 {
  -webkit-animation: 1.2s grow ease-in-out infinite 0.15555s;
  animation: 1.2s grow ease-in-out infinite 0.15555s;
  margin: 0 20px;
}
.dot-loader--3 {
  -webkit-animation: 1.2s grow ease-in-out infinite 0.3s;
  animation: 1.2s grow ease-in-out infinite 0.3s;
}

@keyframes grow {
  0%,
  40%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

 ` ]
})
export class FullLoaderComponent {
  static readonly LOADER_TOKEN = LOADER_PRESET_TOKEN;
}
